// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.account-menu-header ion-toolbar {
  padding: 0 0.625rem;
}
ion-header.account-menu-header ion-toolbar ion-title {
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
  color: var(--ion-color-primary-black);
  padding: 0 !important;
  padding-right: 1.625rem !important;
}
ion-header.account-menu-header:after {
  height: 0 !important;
}

.side-menu {
  background: var(--ion-color-sidemenu-background);
}
.side-menu ion-list {
  background: var(--ion-color-sidemenu-background);
  padding: 0 0 1.375rem 0;
}
.side-menu ion-list ion-item {
  --background: var(--ion-color-sidemenu-background);
  --min-height: 2.1875rem;
}
.side-menu ion-list ion-item a {
  cursor: pointer;
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 3rem;
  padding-left: 0.625rem;
  color: var(--ion-color-primary-black);
  text-decoration: none;
}
.side-menu ion-list ion-item a:active, .side-menu ion-list ion-item a:hover {
  font-weight: 600;
}

.mobile-menu {
  padding: 1rem;
}
.mobile-menu .user-info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--ion-color-secondary-blue);
  padding: 2.8125rem 1.875rem;
}
.mobile-menu .user-info-container .user-details .user-name {
  font-weight: 600;
  font-size: 1.75rem;
  text-align: center;
  color: var(--ion-color-primary-white);
  padding-bottom: 0.4375rem;
}
.mobile-menu .user-info-container .user-details .user-email {
  text-align: center;
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: -0.5px;
  color: var(--ion-color-primary-white);
  opacity: 0.7;
}
.mobile-menu .user-info-container .connect-to-account .connect-label {
  text-align: center;
  font-weight: 600;
  font-size: 1.5rem;
  text-align: center;
  color: var(--ion-color-primary-white);
  padding-bottom: 0.4375rem;
}
.mobile-menu .user-info-container .connect-to-account .connect-description {
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--ion-color-primary-white);
  text-align: center;
}
.mobile-menu .user-info-container .connect-to-account .buttons-container {
  padding: 1.25rem 0.9375rem 0;
}
.mobile-menu .user-info-container .connect-to-account .buttons-container .connect-buttons {
  margin: 0.3125rem 0.125rem;
  width: 100%;
  border-radius: 2px;
  min-height: 44px;
  text-align: center;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}
.mobile-menu .user-info-container .connect-to-account .buttons-container .connect-buttons .arrowIcon {
  position: absolute;
  right: 2.8125rem;
}
.mobile-menu .user-info-container .connect-to-account .buttons-container .register-btn {
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-white);
}
.mobile-menu .user-info-container .connect-to-account .buttons-container .login-btn {
  color: var(--ion-color-primary);
  background: var(--ion-color-primary-white);
}
.mobile-menu .menu-list {
  padding: 1.5rem 0.625rem;
}
.mobile-menu .menu-list .menu-icon {
  margin-right: 1.5rem;
}
.mobile-menu .menu-list .menu-list-label {
  font-weight: 400;
  font-size: 1.0625rem;
  line-height: 1.25rem;
  color: var(--ion-color-primary-black);
  margin: 1.25rem 0;
}
.mobile-menu .menu-list .outer-item {
  --padding-start: 0 !important;
}
.mobile-menu .menu-list .outer-item .inner-item {
  width: 100%;
  --padding-start: 0 !important;
  --inner-padding-end: 0 !important;
}
.mobile-menu .menu-list .bottom-border {
  border-bottom: 1px solid var(--ion-color-primary-border);
}

.item-active-left {
  border-left: 4px solid var(--ion-color-primary) !important;
}
.item-active-left a {
  font-weight: 600 !important;
}

.item-active-right {
  border-right: 4px solid var(--ion-color-primary) !important;
}
.item-active-right a {
  font-weight: 600 !important;
}

.border-left-transparent {
  border-left: 4px solid var(--ion-color-gray-30);
}

.border-right-transparent {
  border-left: 4px solid var(--ion-color-gray-30);
}

.edit-div {
  background: #E0E0E0 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  padding: 1.25rem 0.625rem 0 1.8125rem;
}

.name-div {
  font-weight: bold;
  font-size: 1rem;
  letter-spacing: 0 !important;
  color: var(--ion-color-primary-black);
  opacity: 1;
  margin: 0 0.625rem;
}

.profile-icon {
  max-height: 100px;
  align-items: center;
}

.profile-btns {
  text-transform: capitalize;
  align-self: center;
  padding-top: 0.3125rem;
  padding-left: 0.625rem;
}

.edit-btn {
  font-weight: bold;
  font-size: 0.875rem;
  letter-spacing: 0.4px !important;
  color: var(--ion-color-primary);
  text-transform: uppercase;
  opacity: 1;
  cursor: pointer;
  --padding-start: 0.625rem;
  --padding-end: 0.625rem;
  --padding-bottom: 0.625rem;
}

.seperator {
  border-bottom: 1px solid #D5DADC;
  opacity: 1;
  margin: 1.25rem 1.8125rem 1.125rem 1.875rem;
}

.company-logo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.isMobile .side-menu {
  min-height: unset !important;
}

.web-menu-closed {
  display: none;
}

.web-menu-open {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-account-menu/my-account-menu.component.scss"],"names":[],"mappings":"AACC;EACC,mBAAA;AAAF;AAEE;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,qBAAA;EACA,kCAAA;AAAH;AAIC;EACC,oBAAA;AAFF;;AAMA;EAEC,gDAAA;AAJD;AAMC;EACC,gDAAA;EACA,uBAAA;AAJF;AAME;EACC,kDAAA;EACA,uBAAA;AAJH;AAMG;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qCAAA;EACA,qBAAA;AAJJ;AAMI;EAEC,gBAAA;AALL;;AAaA;EACC,aAAA;AAVD;AAYC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACA,2BAAA;AAVF;AAaG;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;AAXJ;AAcG;EACC,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qCAAA;EACA,YAAA;AAZJ;AAiBG;EACC,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;AAfJ;AAkBG;EACC,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;AAhBJ;AAmBG;EACC,4BAAA;AAjBJ;AAmBI;EACC,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAjBL;AAmBK;EACC,kBAAA;EACA,gBAAA;AAjBN;AAqBI;EACC,oCAAA;EACA,qCAAA;AAnBL;AAsBI;EACC,+BAAA;EACA,0CAAA;AApBL;AA0BC;EACC,wBAAA;AAxBF;AA0BE;EACC,oBAAA;AAxBH;AA2BE;EACC,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qCAAA;EACA,iBAAA;AAzBH;AA4BE;EACC,6BAAA;AA1BH;AA4BG;EACC,WAAA;EACA,6BAAA;EACA,iCAAA;AA1BJ;AA8BE;EACC,wDAAA;AA5BH;;AAiCA;EACC,0DAAA;AA9BD;AAgCC;EACC,2BAAA;AA9BF;;AAkCA;EACC,2DAAA;AA/BD;AAiCC;EACC,2BAAA;AA/BF;;AAmCA;EACC,+CAAA;AAhCD;;AAoCA;EACC,+CAAA;AAjCD;;AAoCA;EACC,+CAAA;EACA,UAAA;EACA,aAAA;EACA,qCAAA;AAjCD;;AAoCA;EACC,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,qCAAA;EACA,UAAA;EACA,kBAAA;AAjCD;;AAoCA;EACC,iBAAA;EACA,mBAAA;AAjCD;;AAoCA;EACC,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AAjCD;;AAoCA;EACC,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;AAjCD;;AAoCA;EACC,gCAAA;EACA,UAAA;EACA,2CAAA;AAjCD;;AAoCA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAjCD;;AAqCC;EACC,4BAAA;AAlCF;;AAsCA;EACC,aAAA;AAnCD;;AAsCA;EACC,cAAA;AAnCD","sourcesContent":["ion-header.account-menu-header {\n\tion-toolbar {\n\t\tpadding: 0 0.625rem;\n\n\t\tion-title {\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 1.25rem;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\tpadding: 0 !important;\n\t\t\tpadding-right: 1.625rem !important;\n\t\t}\n\t}\n\n\t&:after {\n\t\theight: 0 !important;\n\t}\n}\n\n.side-menu {\n\t// min-height: 3230px;\n\tbackground: var(--ion-color-sidemenu-background);\n\n\tion-list {\n\t\tbackground: var(--ion-color-sidemenu-background);\n\t\tpadding: 0 0 1.375rem 0;\n\n\t\tion-item {\n\t\t\t--background: var(--ion-color-sidemenu-background);\n\t\t\t--min-height: 2.1875rem;\n\n\t\t\ta {\n\t\t\t\tcursor: pointer;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 1.1rem;\n\t\t\t\tline-height: 3rem;\n\t\t\t\tpadding-left: 0.625rem;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\ttext-decoration: none;\n\n\t\t\t\t&:active,\n\t\t\t\t&:hover {\n\t\t\t\t\tfont-weight: 600;\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mobile-menu {\n\tpadding: 1rem;\n\n\t.user-info-container {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: var(--ion-color-secondary-blue);\n\t\tpadding: 2.8125rem 1.875rem;\n\n\t\t.user-details {\n\t\t\t.user-name {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 1.75rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\tpadding-bottom: 0.4375rem\n\t\t\t}\n\n\t\t\t.user-email {\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\tline-height: 1.125rem;\n\t\t\t\tletter-spacing: -0.5px;\n\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\topacity: 0.7;\n\t\t\t}\n\t\t}\n\n\t\t.connect-to-account {\n\t\t\t.connect-label {\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 1.5rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\tpadding-bottom: 0.4375rem;\n\t\t\t}\n\n\t\t\t.connect-description {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\t\t\t.buttons-container {\n\t\t\t\tpadding: 1.25rem 0.9375rem 0;\n\n\t\t\t\t.connect-buttons {\n\t\t\t\t\tmargin: 0.3125rem 0.125rem;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\tmin-height: 44px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t\ttext-transform: uppercase;\n\n\t\t\t\t\t.arrowIcon {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tright: 2.8125rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.register-btn {\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\t}\n\n\t\t\t\t.login-btn {\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\tbackground: var(--ion-color-primary-white);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.menu-list {\n\t\tpadding: 1.5rem 0.625rem;\n\n\t\t.menu-icon {\n\t\t\tmargin-right: 1.5rem;\n\t\t}\n\n\t\t.menu-list-label {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 1.0625rem;\n\t\t\tline-height: 1.25rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\tmargin: 1.25rem 0;\n\t\t}\n\n\t\t.outer-item {\n\t\t\t--padding-start: 0 !important;\n\n\t\t\t.inner-item {\n\t\t\t\twidth: 100%;\n\t\t\t\t--padding-start: 0 !important;\n\t\t\t\t--inner-padding-end: 0 !important;\n\t\t\t}\n\t\t}\n\n\t\t.bottom-border {\n\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\t\t}\n\t}\n}\n\n.item-active-left {\n\tborder-left: 4px solid var(--ion-color-primary) !important;\n\n\ta {\n\t\tfont-weight: 600 !important;\n\t}\n}\n\n.item-active-right {\n\tborder-right: 4px solid var(--ion-color-primary) !important;\n\n\ta {\n\t\tfont-weight: 600 !important;\n\t}\n}\n\n.border-left-transparent {\n\tborder-left: 4px solid var(--ion-color-gray-30);\n\n}\n\n.border-right-transparent {\n\tborder-left: 4px solid var(--ion-color-gray-30);\n}\n\n.edit-div {\n\tbackground: #E0E0E0 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tdisplay: flex;\n\tpadding: 1.25rem 0.625rem 0 1.8125rem;\n}\n\n.name-div {\n\tfont-weight: bold;\n\tfont-size: 1rem;\n\tletter-spacing: 0 !important;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tmargin: 0 0.625rem;\n}\n\n.profile-icon {\n\tmax-height: 100px;\n\talign-items: center;\n}\n\n.profile-btns {\n\ttext-transform: capitalize;\n\talign-self: center;\n\tpadding-top: 0.3125rem;\n\tpadding-left: 0.625rem;\n}\n\n.edit-btn {\n\tfont-weight: bold;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0.4px !important;\n\tcolor: var(--ion-color-primary);\n\ttext-transform: uppercase;\n\topacity: 1;\n\tcursor: pointer;\n\t--padding-start: 0.625rem;\n\t--padding-end: 0.625rem;\n\t--padding-bottom: 0.625rem;\n}\n\n.seperator {\n\tborder-bottom: 1px solid #D5DADC;\n\topacity: 1;\n\tmargin: 1.25rem 1.8125rem 1.125rem 1.875rem;\n}\n\n.company-logo {\n\twidth: 70px;\n\theight: 70px;\n\tborder-radius: 50%;\n}\n\n.isMobile {\n\t.side-menu {\n\t\tmin-height: unset !important;\n\t}\n}\n\n.web-menu-closed {\n\tdisplay: none;\n}\n\n.web-menu-open {\n\tdisplay: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
